const constants = {
  user: "Email",
  password: "Contraseña",
  login: "Ingresar",
};
export default constants;
